import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {AccountLink} from 'src/components/links';

import {
    userSearchResultAccountsDataSelector,
    userSearchResultAccountsResultSelector,
} from '../../slices/user-search-result-accounts.slice';

type Props = {
    place: string,
    accountId: number,
};

export const AccountCell = ({accountId, place}: Props) => {
    const {isLoading, loadingError} = useSelector(userSearchResultAccountsDataSelector);
    const result = useSelector(userSearchResultAccountsResultSelector);

    const accountName = useMemo(() => result?.data[accountId], [result, accountId]);

    if (isLoading || loadingError || !accountName) {
        return null;
    }

    return (
        <AccountLink
            accountId={accountId}
            place={place}
            accountName={accountName}
        />
    );
};
